import React, { useEffect } from 'react';
import { Navbar } from '../../components/Navbar';
import { StickyFooter } from '../../components/StickyFooter';
import { CheckCircleIcon, HeartIcon, ShieldCheckIcon, StarIcon } from 'lucide-react';
export function NanniesUS() {
  useEffect(() => {
    document.title = "Find Vetted Nannies & Childcare in Raleigh-Durham & NC Triangle | Care Nomad";
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-2361" data-mp="2e9g1hqin6dlr">
      <Navbar data-id="element-2362" data-mp="2e8wlwgggs1aw" />
      
      <main className="flex-1" data-id="element-2363" data-mp="2j89hpqpbcipm">
        {/* Hero Section */}
        <section className="w-full relative py-12 lg:py-16 flex items-center justify-center min-h-[40vh]" data-id="element-2364" data-mp="2j6on61300zrr">
          <div className="absolute inset-0 z-0" data-id="element-2365" data-mp="2nzrgq97s097y">
            <img src="https://images.unsplash.com/photo-1587691592099-24045742c181?w=1200&auto=format&fit=crop" alt="Nannies Background" className="w-full h-full object-cover" data-id="element-2366" data-mp="2sylyd7u0brqh" />
            <div className="absolute inset-0 bg-[#1a2332]/80" data-id="element-2367" data-mp="31yqw0q9efbrg"></div>
          </div>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-2368" data-mp="31wo3nzkrx6jk">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight mb-4" data-id="element-2369" data-mp="3a19h01a5epyt">
              Find Vetted Nannies in Raleigh-Durham & NC Triangle
            </h1>
            <p className="text-base sm:text-lg text-white/90 max-w-3xl mx-auto mb-8 leading-relaxed" data-id="element-2370" data-mp="305eswqn5o2on">
              Connect directly with independent, pre-screened nannies and babysitters for full-time, part-time, or event care.
            </p>
            <div className="flex flex-wrap justify-center gap-4" data-id="element-2371" data-mp="3nv0shf7fwjx6">
              <a href="/us/book-now" className="bg-[#5a55ea] hover:bg-[#4b47c4] text-white font-bold py-3 px-8 rounded-full transition-colors text-base shadow-md" data-id="element-2372" data-mp="3nwtxyr6bgy3l">
                Find a Nanny
              </a>
            </div>
          </div>
        </section>

        {/* Marketplace Profiles */}
        <section className="py-20 bg-gray-50" data-id="element-2373" data-mp="fh0jsizgjypp">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2374" data-mp="anyynt8nr2xo">
            <div className="text-center mb-16" data-id="element-2375" data-mp="24w2smkmh142k">
              <h2 className="text-3xl font-bold text-[#1a2332] mb-4" data-id="element-2376" data-mp="24xdxknrnkhv9">Available Nannies in the Triangle</h2>
              <p className="text-[#5a6a7a] text-lg max-w-2xl mx-auto" data-id="element-2377" data-mp="29umgwrojery3">Browse profiles of independent caregivers ready to support your family.</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-2378" data-mp="204t45ncns6s9">
              {[1, 2, 3].map(i => <div key={i} className="bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow flex flex-col" data-id="element-2379" data-mp="1m4ih6vegzccd">
                  <div className="p-6 flex-1 flex flex-col" data-id="element-2380" data-mp="1c7nfy4qtaxue">
                    <div className="flex items-center gap-4 mb-4" data-id="element-2381" data-mp="1c989ps5aycr7">
                      <div className="w-16 h-16 bg-gray-200 rounded-full overflow-hidden" data-id="element-2382" data-mp="1h7jli8f5qxc2">
                        <img src={`https://images.unsplash.com/photo-1544281679-44463372c544?w=150&auto=format&fit=crop&q=${i}`} alt="Nanny" className="w-full h-full object-cover" data-id="element-2383" data-mp="36l586525wivr" />
                      </div>
                      <div data-id="element-2384" data-mp="zy7kaib9nqq9">
                        <h3 className="font-bold text-xl text-[#1a2332]" data-id="element-2385" data-mp="zxfnj45xnmye">Sarah M.</h3>
                        <div className="flex items-center gap-1 text-sm font-bold text-[#1a2332]" data-id="element-2386" data-mp="uzmjago6x30r">
                          <StarIcon className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-2387" data-mp="19oing2n4lvw3" />
                          4.9 <span className="text-gray-500 font-normal" data-id="element-2388" data-mp="14vh9bwuqu0dk">(42 reviews)</span>
                        </div>
                      </div>
                    </div>
                    
                    <div className="flex justify-between items-center mb-4" data-id="element-2389" data-mp="1dnrhl8m2vvs6">
                      <span className="text-[#007a87] font-medium" data-id="element-2390" data-mp="1sm3f1hh9z8ke">Full-Time Nanny</span>
                      <span className="font-bold text-lg text-[#1a2332]" data-id="element-2391" data-mp="1nm7a9g0r7d3s">$22/hr</span>
                    </div>

                    <p className="text-gray-600 text-sm mb-6 line-clamp-3" data-id="element-2392" data-mp="3ucev8z9b0vg9">
                      "I have 5 years of experience working with infants and toddlers. I love organizing educational activities and spending time outdoors!"
                    </p>

                    <div className="flex flex-wrap gap-2 mb-6" data-id="element-2393" data-mp="2gjj7a3z8q3rj">
                      <span className="bg-gray-100 text-gray-700 px-2.5 py-1 rounded-md text-xs font-medium flex items-center gap-1" data-id="element-2394" data-mp="2leymp0cwc7q2">
                        <ShieldCheckIcon className="w-3 h-3 text-[#007a87]" data-id="element-2395" data-mp="2qdi8n0rhpjif" /> CPR Certified
                      </span>
                      <span className="bg-gray-100 text-gray-700 px-2.5 py-1 rounded-md text-xs font-medium flex items-center gap-1" data-id="element-2396" data-mp="1xqxho1exf9fe">
                        <ShieldCheckIcon className="w-3 h-3 text-[#007a87]" data-id="element-2397" data-mp="22qju48mxkln5" /> Background Checked
                      </span>
                    </div>

                    <a href="/us/book-now" className="mt-auto w-full bg-white border-2 border-[#5a55ea] text-[#5a55ea] hover:bg-[#5a55ea] hover:text-white font-bold py-3 rounded-xl transition-colors flex items-center justify-center text-center" data-id="element-2398" data-mp="2bi276aokylc0">
                      Connect with Nanny
                    </a>
                  </div>
                </div>)}
            </div>
          </div>
        </section>

        {/* Legal Disclaimer */}
        <section className="py-12 bg-white border-t border-gray-100" data-id="element-2399" data-mp="16kgofuuidd4v">
          <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-2400" data-mp="12gsj7itcmtms">
            <p className="text-sm text-gray-500" data-id="element-2401" data-mp="12jerxlrz7f6l">
              Care Nomad US operates as a technology marketplace platform connecting families with independent caregivers. Care Nomad is not a licensed home health agency in NC or MD.
            </p>
          </div>
        </section>
      </main>

      <StickyFooter data-id="element-2402" data-mp="nqup6m8qn9po" />
    </div>;
}